import api from "./api";
import { AuthResponse } from "../model/types";

export const appLogin = async (payload: {
  email: string;
  password: string;
}): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/signin", payload);
  return response.data;
};

export const appSignup = async (payload: {
  fullName: string;
  email: string;
  password: string;
}): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/signup", payload);
  return response.data;
};
